<script>
import {
  userMethods,
  fraudplusOrderReportMethod,
  fraudplusMethod,
  toasterMethods,
} from '@state/helpers'
import constant from '@constants/constant'
import accesslevels from '@utils/accesslevels'
import ParticipantSearchInfo from '@components/FraudPlusReport/participantSearchInfo'
import BorrowerDetails from './borrowerDetails.vue'

export default {
  components: {
    ParticipantSearchInfo,
    BorrowerDetails,
  },
  props: {
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      isShowBorrower: false,
      isShowProperty: false,
      isShowParticipant: false,
      isShowEmployment: false,
      participantItems: [],
      updateParticipantModal: false,
      editRequestData: {},
      participantFields: [
        {
          key: 'Role',
          label: 'Role',
          class: 'text-left',
        },
        {
          key: 'Type',
          label: 'Type',
          class: 'text-left',
        },
        {
          key: 'FirstName',
          label: 'First Name',
          class: 'text-left',
        },
        {
          key: 'MiddleName',
          label: 'MIddle Name',
          class: 'text-left',
        },
        {
          key: 'LastName',
          label: 'Last Name',
          class: 'text-left',
        },
        {
          key: 'LicenseNumber',
          label: 'License Number',
          class: 'text-left',
        },
        {
          key: 'CompanyName',
          label: 'Company Name',
          class: 'text-left',
        },
        {
          key: 'StateName',
          label: 'State',
          class: 'text-left',
        },
        {
          key: 'action',
          label: 'Action',
          class: 'text-center',
        },
      ],
      errorLog: '',
      packageDesc: '',
      fraudPackages: '',
      packafraudPlusPge: '',
      showSpinner: false,
      selectedFraudPlusPackage: '',
      referenceno: '',
      propertyStreetAddress: '',
      propertyCityName: '',
      propertyState: '',
      propertyZip: '',
      propertyType: '',
      propertyAPN: '',
      propertyOwnersLastName: '',
      propertyPurchasePrice: '',
      maxbirtdate: '',
      state: [],
      isAddOrUpdate: false,
      fraudPackagesList: [],
      sameResidentialAddress: 'not_same',
      ownershipLists: [
        {
          text: 'Rent',
          value: 'Rent',
        },
        { text: 'Own', value: 'Own' },
      ],
      propertyTypesList: [
        { text: 'Single Family Residential', value: 'Single' },
        { text: 'Condominium', value: 'Condominium' },
        { text: '2 to 4 Units', value: '2 to 4 Units' },
        { text: 'manufactured Housing', value: 'manufactured' },
      ],
      participantRoleOptions: [],
      borrowerDetails: [],
      borrowerCount: constant.FPlusBorrowerCount,
      isResidentAddressMandatory: false,
    }
  },
  computed: {
    placeholders() {
      return {
        referenceno: 'Reference Number',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        cityName: 'City Name',
        state: 'Select State',
        ssn: 'xxx-xx-xxxx',
        zip: 'xxxxx-xxxx',
        streetAddress: 'Street Address',
        phoneNumber: '(xxx) xxx-xxxx',
        driverLicenseNumber: 'Driver License #',
        creditFile: 'credit File',
        borrowerDriverLicenseNumber: 'Driver License Number',
        borrowerCreditFile: 'Credit File',
        employerName: 'Employer Name',
        propertyAPN: 'APN',
        propertyOwnersLastName: "Owner's Last Name",
        purchasePrice: 'Purchase Price',
        participantLicense: 'Participant License',
        participantCompany: 'Company Name',
        participantZip: 'xxxxx',
      }
    },
    states() {
      return this.$_allStates
    },
    sendEditRequestData() {
      return this.editRequestData
    },
    sameResidentialAddressEnabled () {
      let firstBorrower = this.borrowerDetails[0]
        if (firstBorrower.residentialStreetAddress !== '' && firstBorrower.residentialCityName !== '' && firstBorrower.residentialState !== '' && firstBorrower.residentialZip !== '' ) {
          return false
        } else return true
       }
  },
  mounted() {
    this.isCustRequestor = accesslevels(9)
    this.getAllPackages()
  },
  methods: {
    ...userMethods,
    ...fraudplusOrderReportMethod,
    ...fraudplusMethod,
    ...toasterMethods,
    /* eslint-disable no-console */
    getStateCode(stat) {
      let state = stat
        ? this.states.find((state) => state.text === stat).stateCode
        : null
      return state
    },

    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'OK').then(() => {
        if (method) {
          method()
        }
      })
    },
    formatData(value) {
      return value ? value.trim() : value || null
    },
    confirmCancelClicked() {
      this.updateParticipantModal = false
    },
    updateParticipantRecord(item) {
      this.participantItems.splice(
        item.UpdateRequestObject.participantRecordIndex,
        1,
        item.UpdateRequestObject.ParticipantsOrders
      )
      this.updateParticipantModal = false
    },
    EditParticipantData(item) {
      this.updateParticipantModal = true
      this.editRequestData = item
    },
    LoadFraudPlusFields(packageItem) {
      if (this.borrowerDetails.length) {
        this.borrowerDetails = []
        try {
          let res = this.$refs.borrow
          res.customErrors.length = 0
        }
       catch (error) {
        console.error(error,'Refernce to borrow is undefined')
       }
      }
      // Dynamic order page mappings
      this.isShowBorrower = packageItem.borrowerInformation
      this.isShowProperty = packageItem.propertyInformation
      this.isShowEmployment =
        packageItem.employerValidation || packageItem.googleDistanceReport
      this.isShowParticipant = packageItem.participantInformation
      this.isResidentAddressMandatory = packageItem.verificationOfOccupancy
      if (!this.borrowerDetails.length) {
        this.addBorrowerField()
      }
      if (this.isShowParticipant) {
        this.getFraudPlusRoles(packageItem)
      }
    },
    getAllPackages() {
      this.showSpinner = true
      this.fetchPackagesforUserOrder({
        userId: this.customerUserId,
        productId: this.productId,
      })
        .then((response) => {
          this.showSpinner = false
          this.fraudPackagesList = []
          this.fraudPackages = response.data.fraudPlusPackages
          for (let i = 0; i < response.data.fraudPlusPackages.length; i++) {
            this.fraudPackagesList.push({
              text: response.data.fraudPlusPackages[i].packageName,
              value: response.data.fraudPlusPackages[i].fraudPlusPackageId,
            })
          }
        })
        .catch((error) => {
          this.showSpinner = false
          this.autherror = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
    },

    getPackageDescription(event) {
      if (this.selectedFraudPlusPackage) {
        let code = this.selectedFraudPlusPackage
        let i = 0
        for (i = 0; i < this.fraudPackages.length; i++) {
          if (this.fraudPackages[i].fraudPlusPackageId === Number(code)) {
            this.packageDesc = this.fraudPackages[i].packageDescription
          }
        }
        this.showSpinner = true
        this.fetchFRaudXPackageDetails(this.selectedFraudPlusPackage)
          .then((response) => {
            this.LoadFraudPlusFields(
              response.data.length ? response.data[0] : null
            )
          })
          .catch((error) => {
            this.autherror = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
          })
          .finally(() => (this.showSpinner = false))
      }
    },
    getFraudPlusRoles(packageItem) {
      if (packageItem !== null) {
        this.isShowParticipant = false
        this.showSpinner = true
        this.fetchFPlusRolesForBridger()
          .then((response) => {
            if (response.status === 200) {
              this.participantRoleOptions = response.data.length
                ? packageItem.ascNationalRegistryOfAppraiser &&
                  !packageItem.participantWatchlist
                  ? constant.FraudXParticipantRoles
                  : response.data
                : []
              this.isShowParticipant = true
            }
          })
          .catch((error) => {
            this.autherror = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
          })
          .finally(() => (this.showSpinner = false))
      }
    },
    getEmployerData(list) {
      let employerList = list || []
      let builtEmployerData = []
      builtEmployerData = employerList.map((emp) => {
        return {
          employerName: this.formatData(emp.employerName),
          employmentPhone: this.formatData(
            emp.employmentPhone.replace(/[^0-9]+/g, '')
          ),
          employmentStatus: this.formatData(emp.employmentStatus),
          employmentStreetAddress: this.formatData(
            emp.employmentStreetAddress
          ),
          employmentCityName: this.formatData(emp.employmentCityName),
          employmentState: this.formatData(emp.employmentState),
          employmentZip: this.formatData(emp.employmentZip),
        }
      })
      return builtEmployerData
    },
    buildFraudPlusRequest() {
      let userInfo = this.$store.state.auth.currentUser.userInfo
      if (this.isCustRequestor) {
        this.customerUserId = userInfo.userId
      }
      let borrowerInfo = []
      if (this.isShowBorrower) {
        borrowerInfo = (this.borrowerDetails || []).map((item, index) => {
          return {
            borrowerFirstName: this.formatData(item.firstName),
            borrowerMiddleName: this.formatData(item.middleName),
            borrowerLastName: this.formatData(item.lastName),
            borrowerSSN: this.formatData(item.ssn.replace(/[^0-9]+/g, '')),
            borrowerDateofBirth: this.formatData(item.dateOfBirth),
            borrowerPhoneNumber: this.formatData(
              item.phoneNumber.replace(/[^0-9]+/g, '')
            ),
            borrowerDriverLicenseNumber: this.formatData(
              item.driverLicenseNumber
            ),
            borrowerDriverLicenseState: this.formatData(
              item.driverLicenseState
            ),
            borrowerCreditFile: this.formatData(item.creditFile),
            residentialStreetAddress: this.formatData(
              item.residentialStreetAddress
            ),
            residentialCityName: this.formatData(item.residentialCityName),
            residentialState: this.formatData(item.residentialState),
            residentialZip: this.formatData(item.residentialZip),
            residentialOwnership: this.formatData(item.residentialOwnership),
            employerInformation: this.getEmployerData(item.employerData),
          }
        })
      }
      return {
        UserId: userInfo.userId,
        ProductId: this.productId,
        OrderForUser: this.customerUserId,
        OrderForCustomer: this.customerId,
        referenceno: this.referenceno,
        FraudPlusPackage: this.selectedFraudPlusPackage,
        borrowersInformation: borrowerInfo.length ? borrowerInfo : [],
        propertyStreetAddress: this.formatData(this.propertyStreetAddress),
        propertyCityName: this.formatData(this.propertyCityName),
        propertyState: this.formatData(this.propertyState),
        propertyZip: this.formatData(this.propertyZip),
        propertyType: this.formatData(this.propertyType),
        propertyAPN: this.formatData(this.propertyAPN),
        propertyOwnersLastName: this.formatData(this.propertyOwnersLastName),
        propertyPurchasePrice: this.formatData(this.propertyPurchasePrice),
        ParticipantsOrders: this.participantItems,
      }
    },
    validateBorrowerDetails() {
      let res = this.$refs.borrow
      this.borrowerDetails.map((item, index) => {
        res.tfCustomValidation(
          { 'First Name': item.firstName },
          index,
          'required | specialName'
        )
        res.tfCustomValidation(
          { 'Last Name': item.lastName },
          index,
          'required | specialName'
        )
        res.tfCustomValidation({ SSN: item.ssn }, index, 'required | ssn')
        if (item.driverLicenseState !== '') {
          res.tfCustomValidation(
            { 'Driver License Number': item.driverLicenseNumber },
            index,
            'required | dlno'
          )
        } else {
          res.tfCustomValidation(
            { 'Driver License Number': item.driverLicenseNumber },
            index,
            'dlno'
          )
        }
        if(this.isShowEmployment) {
          let employerData = item.employerData || []
          employerData.map((emp, k) => {
          if (!emp.disableEmployer) {
            res.tfCustomValidation({ 'Employer Name': emp.employerName }, index + `'${k}'`, 'required | company')
            res.tfCustomValidation({ State: emp.employmentState }, index + `'${k}'`, 'required')
          }
          })
        }
      })
      this.$refs.borrow.expandForm()
      return res.customErrors.length === 0
    },
    onFraudPlusReportSubmit() {
      var isOrderReportComponentValid = false
      let isParticipantSelected =
        this.isShowParticipant && !this.participantItems.length
      let borrowerValidation = this.isShowBorrower
        ? this.validateBorrowerDetails()
        : true
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (isOrderReportComponentValid && response && borrowerValidation) {
            if (isParticipantSelected) {
              this.getModal('Please add at least one Participant', 'Alert')
              return
            }
            this.showSpinner = true
            this.fetchFraudPlusDistanceCalculation(this.buildFraudPlusRequest())
              .then((response) => {
                if (
                  response &&
                  response.data.orderId !== '' &&
                  response.data.orderId !== null
                ) {
                  this.$router.push({
                    name: 'fraudplusSummaryPage',
                    params: {
                      orderId: response.data.orderId,
                      callOrigin: constant.origin.OrderReport,
                    },
                  })
                } else {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                }
              })
              .catch((error) => {
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
                console.log(error)
              })
              .finally(() => (this.showSpinner = false))
          }
        })
      }).catch((error)=>{
        console.error(error)
      })
    },
    doSameResidentialAddress(value) {
      if (value) {
        let firstBorrower = this.borrowerDetails[0]
        this.propertyStreetAddress = firstBorrower.residentialStreetAddress
        this.propertyCityName = firstBorrower.residentialCityName
        this.propertyState = firstBorrower.residentialState
        this.propertyZip = firstBorrower.residentialZip
      } else {
        this.propertyStreetAddress = ''
        this.propertyCityName = ''
        this.propertyState = ''
        this.propertyZip = ''
      }
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    addParticipantData(data) {
      this.participantItems.push({
        Role: data.participantRole,
        Type: data.participantType,
        FirstName: data.participantFirstName,
        LastName: data.participantLastName,
        LicenseNumber: data.participantLicense,
        CompanyName: data.participantCompany,
        State: data.State,
        StateName: data.StateName,
        MiddleName: data.participantMiddleName,
        Zip: data.participantZip,
        Phone: data.participantPhoneNumber.replace(/[^0-9()-]/, ''),
      })
    },
    deleteParticipantData(index) {
      this.$refs.confirm
        .showAsync(
          'Are you sure you want to delete this record?',
          'Confirm Deletion',
          'Yes',
          'No'
        )
        .then(() => {
          this.participantItems.splice(index, 1)
        })
    },
    addBorrowerField() {
      this.borrowerDetails.push({
        firstName: '',
        middleName: '',
        lastName: '',
        ssn: '',
        dateOfBirth: '',
        phoneNumber: '',
        driverLicenseNumber: '',
        driverLicenseState: '',
        creditFile: '',
        residentialStreetAddress: '',
        residentialCityName: '',
        residentialState: '',
        residentialZip: '',
        residentialInfoMandatory: this.isResidentAddressMandatory,
        residentialOwnership: '',
        isVisibleBorrower: true,
        isShowEmployment: this.isShowEmployment,
        // employerName: '',
        // employmentPhone: '',
        // employmentStatus: 'Currently Employed',
        // employmentStreetAddress: '',
        // employmentCityName: '',
        // employmentState: '',
        // employmentZip: '',
        employerData: [
          {
            employerName: '',
            employmentPhone: '',
            employmentStatus: 'Currently Employed',
            employmentStreetAddress: '',
            employmentCityName: '',
            employmentState: '',
            employmentZip: '',
            disableEmployer: false,
            isVisibleEmployer: true,
          }
       ],
        // disableEmployer:false,
        isResidentialAddress: false,
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseModalLayout ref="confirm" modal-size="md" />
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col md="6">
        <BaseELabel mark-required label="Choose Package" />
        <BaseDropdown
          v-model="selectedFraudPlusPackage"
          v-validate="'required'"
          type="text"
          :options="fraudPackagesList"
          mark-required
          :class="$style.dropOptionstyle"
          @change="getPackageDescription"
        ></BaseDropdown>
      </b-col>
      <b-col md="6">
        <BaseELabel label="Description:" /><p>{{ packageDesc }}</p>
      </b-col>
    </b-row>
    <div v-if="selectedFraudPlusPackage !== ''">
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="referenceno"
            v-model="referenceno"
            v-validate="{ required: false, regex: /^[A-Za-z0-9.'_ ,-]+$/ }"
            validattor="^[A-Za-z0-9.'_ ,-]+$"
            data-vv-as="Reference No."
            type="text"
            maxlength="50"
            name="referenceno"
            label-content="Reference Number"
            :placeholder="placeholders.referenceno"
          ></BaseEInputText>
          <div class="error"> {{ errors.first('referenceno') }} </div>
        </b-col>
      </b-row>
      <div v-if="isShowBorrower">
        <BorrowerDetails
          ref="borrow"
          class="mt-2"
          :borrower-details="borrowerDetails"
        />
        <b-row>
          <b-col>
            <BaseEButton
              class="d-inline-block float-right mb-1 px-3"
              variant="icon"
              :disabled="borrowerDetails.length > borrowerCount"
              @click="addBorrowerField"
              >Add Borrower<BaseIcon name="plus" class="ml-1"> </BaseIcon>
            </BaseEButton>
          </b-col>
        </b-row>
      </div>
      <div v-if="isShowProperty">
        <b-row align-v="center" class="pt-2">
          <b-col md="auto">
            <div>
              <BaseELabel
                :class="$style.labelSubHeading"
                label="Property Information"
              />
            </div>
          </b-col>
          <b-col class="border-bottom"></b-col>
        </b-row>

        <b-row>
          <b-col v-if="isShowBorrower" md="12" class="pt-3">
            <b-form-checkbox
              id="sameResidentialAddress"
              v-model="sameResidentialAddress"
              name="sameResidentialAddress"
              :disabled="sameResidentialAddressEnabled"
              @change="doSameResidentialAddress($event)"
            >
              Is Property Address same as Residential Address?
            </b-form-checkbox>
          </b-col>
          <b-col md="5">
            <BaseEInputText
              id="propertyStreetAddress"
              v-model="propertyStreetAddress"
              v-validate="{ required: true, regex: /^[A-Za-z0-9.'#@%&/ -]+$/ }"
              validattor="^[A-Za-z0-9.'#@%&/ -]+$"
              type="text"
              name="propertyStreetAddress"
              maxlength="100"
              label-content="Street"
              data-vv-as="Street"
              mark-required
              :class="{
                  input: true,
                  'is-danger': errors.has('propertyStreetAddress'),
                }"
              :placeholder="placeholders.streetAddress"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('propertyStreetAddress') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="propertyCityName"
              v-model="propertyCityName"
              v-validate="{ required: true, regex: /^[A-Za-z.' -]+$/ }"
              validattor="^[A-Za-z.' -]+$"
              type="text"
              name="propertyCityName"
              maxlength="20"
              label-content="City"
              mark-required
              data-vv-as="City Name"
              :class="{
                  input: true,
                  'is-danger': errors.has('propertyCityName'),
                }"
              :placeholder="placeholders.cityName"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('propertyCityName') }}
            </div>
          </b-col>
          <b-col md="2">
            <BaseELabel mark-required label="State" />
            <BaseDropdown
              v-model="propertyState"
              v-validate="'required'"
              :field-id="state"
              :options="states"
              name="propertyState"
              :placeholder="placeholders.state"
              :class="$style.dropOptionstyle"
              data-vv-as="State"
            ></BaseDropdown>
            <div class="error">
              {{ errors.first('propertyState') }}
            </div>
          </b-col>
          <b-col md="2">
            <BaseEInputText
              id="propertyZip"
              v-model="propertyZip"
              v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
              validattor="[0-9]"
              maskker="(\d{5})(\d{4})"
              formatter="$1-$2"
              type="text"
              maxlength="10"
              name="propertyZip"
              label-content="Zip"
              data-vv-as="Zip"
              mark-required
              :class="{
                  input: true,
                  'is-danger': errors.has('propertyZip'),
                }"
              :placeholder="placeholders.zip"
            ></BaseEInputText>
            <div class="error"> {{ errors.first('propertyZip') }} </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <BaseELabel label="Property Type" />
            <BaseDropdown
              v-model="propertyType"
              :field-id="propertyType"
              :options="propertyTypesList"
              name="propertyType"
              data-vv-as="Property Type"
              :class="$style.dropOptionstyle"
            ></BaseDropdown>

            <div class="error"> {{ errors.first('propertyType') }} </div>
          </b-col>
          <b-col md="2">
            <BaseEInputText
              id="propertyAPN"
              v-model="propertyAPN"
              type="text"
              name="propertyAPN"
              maxlength="50"
              label-content="APN"
              data-vv-as="APN"
              :class="{
                  input: true,
                  'is-danger': errors.has('propertyAPN'),
                }"
              :placeholder="placeholders.propertyAPN"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('propertyAPN') }}
            </div>
          </b-col>
          <b-col md="2">
            <BaseEInputText
              id="propertyOwnersLastName"
              v-model="propertyOwnersLastName"
              v-validate="{ required: false, regex: /^[A-Za-z -.]+$/ }"
              validattor="^[A-Za-z -.]+$"
              type="text"
              maxlength="20"
              name="propertyOwnersLastName"
              label-content="Owner's Last Name"
              data-vv-as="Owner's Last Name"
              :class="{
                  input: true,
                  'is-danger': errors.has('propertyOwnersLastName'),
                }"
              :placeholder="placeholders.propertyOwnersLastName"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('propertyOwnersLastName') }}
            </div>
          </b-col>
          <b-col md="2">
            <BaseEInputText
              id="propertyPurchasePrice"
              v-model="propertyPurchasePrice"
              v-validate="{ required: false }"
              validattor="[0-9]"
              type="text"
              maxlength="10"
              name="propertyPurchasePrice"
              label-content="Purchase Price"
              data-vv-as="Purchase Price"
              :class="{
                  input: true,
                  'is-danger': errors.has('propertyPurchasePrice'),
                }"
              :placeholder="placeholders.purchasePrice"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('propertyPurchasePrice') }}
            </div>
          </b-col>
        </b-row>
      </div>
      <template v-if="isShowParticipant">
        <ParticipantSearchInfo
          :role-options="participantRoleOptions"
          @addParticipantData="addParticipantData"
        />
        <b-row>
          <b-col>
            <b-table
              :items="participantItems"
              :fields="participantFields"
              hover
              striped
              bordered
              responsive
            >
              <template v-slot:cell(StateName)="row">
                {{ getStateCode(row.item.StateName) }}
              </template>
              <template v-slot:cell(action)="row">
                <BaseIcon
                  size="sm"
                  name="pencil-alt"
                  class="cursor-pointer"
                  @click="EditParticipantData(row)"
                />
                <BaseIcon
                  size="sm"
                  name="times-circle"
                  class="ml-2 cursor-pointer"
                  @click="deleteParticipantData(row.index)"
                />
              </template>
            </b-table>
          </b-col>
        </b-row>
      </template>

      <b-row>
        <b-col md="12" class="border-bottom pb-3" />
      </b-row>
      <b-row class="mt-4">
        <b-col md="2">
          <BaseEButton @click="onFraudPlusReportSubmit">
            Submit
          </BaseEButton>
        </b-col>
      </b-row>
    </div>
    <BaseModalLayout
      :show-modal="updateParticipantModal"
      modal-title="Edit Participant"
      modal-size="lg"
      hide-ok
      hide-cancel
    >
      <ParticipantSearchInfo
        :edit-request-data="sendEditRequestData"
        :role-options="participantRoleOptions"
        :update-mode="true"
        @addParticipantData="addParticipantData"
        @confirmCancelClicked="confirmCancelClicked"
        @updateParticipantRecord="updateParticipantRecord"
      />
    </BaseModalLayout>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
